import { useContext } from 'react';
import { SensorsStoreContext } from './sensors-provider';
import { SensorsStore } from './sensors-store';

export function useSensorsStore(): SensorsStore {
    const store = useContext(SensorsStoreContext);
    if (!store) {
        throw new Error('Unexpectedly did not find value for SensorsStoreContext');
    }
    return store;
}
